<script setup lang="ts">
import KsoWavesView from "@innoclouds/ui/templates/kso/ksoWaves/KsoWaves.vue";
import { useDecorationStore } from "#/store/decoration";

const props = defineProps<{ decoration?: string }>();

const decor = useDecorationStore().screen(props.decoration);
</script>

<template>
	<KsoWavesView :decor="decor" />
</template>
